// src/components/calendar/TodayDashboardWrapper.tsx
import { TodayDashboard } from "./TodayDashboard"
import { cn } from "@/lib/utils"

interface TodayDashboardWrapperProps {
  viewLevel: 1 | 3 | 12
  className?: string
}

export function TodayDashboardWrapper({ viewLevel, className }: TodayDashboardWrapperProps) {
  // Показываем ТОЛЬКО в режиме одного месяца
  if (viewLevel !== 1) return null

  return (
    <div
      className={cn(
        "w-full lg:w-96 xl:w-[420px]", // ← расширен вправо (можно увеличить до [480px])
        "mt-9 lg:mt-0 lg:ml-9", // отступ слева на десктопе
        "bg-gradient-to-br from-purple-950/80 to-indigo-950/80",
        "border border-purple-600/50 rounded-3xl",
        "shadow-2xl shadow-purple-900/50 backdrop-blur-sm",
        "overflow-hidden",
        className
      )}
    >
      <TodayDashboard />
    </div>
  )
}